import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IdCompanyDto } from '@/services/ws-companies/src/main/resources/rest-api';
import { Filter } from '@/js/libs/ui/src/V2';
import type { IdentityRole } from '@/js/libs/use-auth';

import type { Option } from 'src/types';
import { useCompaniesOptions } from '../hooks/useCompaniesOptions';

interface CompaniesFilterProps {
  selected?: Option<IdCompanyDto>[];
  onChange: (selected: Option<IdCompanyDto>[]) => void;
  permissions: IdentityRole[];
}

export const CompaniesFilter: React.FC<CompaniesFilterProps> = React.memo(function CompaniesFilter({ selected, onChange, permissions }) {
  const [t] = useTranslation(['backend', 'common']);
  const { options, pending } = useCompaniesOptions(permissions);

  return (
    <Filter<IdCompanyDto>
      loading={pending}
      label={t('common:SELECT_COMPANY')}
      options={options}
      selected={selected || []}
      onChange={onChange}
      dataTestId='company-dropdown'
      isMulti
    />
  );
});
